/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
var add_button = document.querySelector('.custom_button');
var first_input = document.querySelector('#first_style');
var second_input = document.querySelector('#second_style');
var third_input = document.querySelector('#third_style');
var boxes = document.querySelector('.boxes');
var first_block = document.querySelector('.first_block');
var second_block = document.querySelector('.second_block');
var third_block = document.querySelector('.third_block');

/* --- AQUI ESTÁ LA CORRECCIÓN SALVAVIDAS --- */
var inner_heading_text = document.querySelector('.inner-heading-text')?.innerText || '';
var select_button_text = document.querySelector('.select-button-text')?.innerText || '';
var change_button_text = document.querySelector('.change-button-text')?.innerText || '';
/* ----------------------------------------- */

var current_value,current_selected,limit,pop_main,pop_cross,pop_submit,over_lay,before_content,after_content,style_buttons,active_items,items,current_block;

before_content = `<div class="image_part"><svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 24 24"><path fill="currentColor" d="M10.6 16q0-2.025.363-2.913q.362-.887 1.537-1.937q1.025-.9 1.562-1.563q.538-.662.538-1.512q0-1.025-.687-1.7Q13.225 5.7 12 5.7q-1.275 0-1.938.775q-.662.775-.937 1.575L6.55 6.95q.525-1.6 1.925-2.775Q9.875 3 12 3q2.625 0 4.038 1.463q1.412 1.462 1.412 3.512q0 1.25-.537 2.138q-.538.887-1.688 2.012Q14 13.3 13.738 13.912q-.263.613-.263 2.088Zm1.4 6q-.825 0-1.412-.587Q10 20.825 10 20q0-.825.588-1.413Q11.175 18 12 18t1.413.587Q14 19.175 14 20q0 .825-.587 1.413Q12.825 22 12 22Z"/></svg>
</div><div class="text_button"><h1 class="Heading u-h3">${inner_heading_text}</h1><div class="select_style">${select_button_text}</div></div>`;

over_lay = document.querySelector('.PageOverlay');
pop_main = document.querySelector('.main_pop');
pop_cross = document.querySelector('.cross');
pop_submit = document.querySelector('.submit_button');
function disabledButton() {
  if (!add_button) return; // ESCUDO: Si no hay botón en esta página, cancela la acción en silencio.
  if (!add_button.getAttribute('disabled')) {
    add_button.setAttribute('disabled','disabled');
    add_button.classList.remove('ProductForm__AddToCart');
  }
}

function enabledButton() {
  if (!add_button) return; // ESCUDO: Si no hay botón en esta página, cancela la acción en silencio.
  if (add_button.getAttribute('disabled')) {
    add_button.removeAttribute('disabled');
    add_button.classList.add('ProductForm__AddToCart');
  }
} /* <--- Asegúrate de que esta llave esté aquí */

function currentVariant() {
  current_selected = document.querySelector('select[name="id"]');
  
  // ESCUDO: Si no hay selector de variantes en esta página, no hagas nada.
  if (!current_selected) return; 
  
  current_value = current_selected.options[current_selected.selectedIndex].text;
}

function checkLimit() {
  // ESCUDO: Si el valor está vacío (no estamos en el producto correcto), cancelamos.
  if (!current_value) return;

  if (current_value.includes('Una lámina') || current_value.includes('A sheet') || current_value.includes('Un Autocollant') || current_value.includes('Uma folha')) {
    limit = 1;
    if(boxes) boxes.classList.remove('n-visible');
    if(first_block) { first_block.classList.add('visible','empty'); first_block.classList.remove('n-visible','filled'); }
    if(second_block) { second_block.classList.add('n-visible','empty'); second_block.classList.remove('visible','filled'); }
    if(third_block) { third_block.classList.add('n-visible','empty'); third_block.classList.remove('visible','filled'); }
  }

  if (current_value.includes('Dos láminas') || current_value.includes('Two sheets') || current_value.includes('Deux Autocollants') || current_value.includes('Duas folhas')) {
    limit = 2;
    if(boxes) boxes.classList.remove('n-visible');
    if(first_block) { first_block.classList.add('visible','empty'); first_block.classList.remove('n-visible','filled'); }
    if(second_block) { second_block.classList.add('visible','empty'); second_block.classList.remove('n-visible','filled'); }
    if(third_block) { third_block.classList.add('n-visible','empty'); third_block.classList.remove('visible','filled'); }
  }
  
  if (current_value.includes('Tres láminas') || current_value.includes('Three sheets') || current_value.includes('Trois Autocollants') || current_value.includes('Três folhas')) {
    limit = 3;
    if(boxes) boxes.classList.remove('n-visible');
    if(first_block) { first_block.classList.add('visible','empty'); first_block.classList.remove('n-visible','filled'); }
    if(second_block) { second_block.classList.add('visible','empty'); second_block.classList.remove('n-visible','filled'); }
    if(third_block) { third_block.classList.add('visible','empty'); third_block.classList.remove('n-visible','filled'); }
  }
  
  if(first_block) first_block.innerHTML = before_content;
  if(second_block) second_block.innerHTML = before_content;
  if(third_block) third_block.innerHTML = before_content;

  if (current_value.includes('Sin láminas') || current_value.includes('Without Gel nails') || current_value.includes('Sans Autocollants') || current_value.includes('Sem folhas')) {
    limit = 0;
    if(boxes) boxes.classList.add('n-visible');
    if(first_block) { first_block.classList.remove('visible', 'filled'); first_block.classList.add('n-visible', 'empty'); }
    if(second_block) { second_block.classList.remove('visible', 'filled'); second_block.classList.add('n-visible', 'empty'); }
    if(third_block) { third_block.classList.remove('visible','filled'); third_block.classList.add('n-visible','empty'); }
    enabledButton();
  }
}

function buttonClick(){
  style_buttons = document.querySelectorAll('.select_style');
  style_buttons.forEach(function(style_btn) {
  style_btn.addEventListener('click', function() {
    showPop();
    current_block = this.parentNode.parentNode;
   });
 });
}

function showPop(){
  over_lay.classList.add('is-visible');
  pop_main.classList.add('shown');
  pop_submit.classList.add('disable');
  items = document.querySelectorAll('.one-item');
  items.forEach(function(item) {
    item.addEventListener('click',function () {
      var current_active = document.querySelector('.one-item.active');
      
      if(current_active){
        current_active.classList.remove('active');
      }
      
     this.classList.add('active'); 
      pop_submit.classList.remove('disable');
    });
  });
}

function closePop(){
  over_lay.classList.remove('is-visible');
  pop_main.classList.remove('shown');
  
  var current_active = document.querySelector('.one-item.active');
  
  if(current_active){
    current_active.classList.remove('active');
    pop_submit.classList.add('disable');
  }
}

function submitPop() {
  over_lay.classList.remove('is-visible');
  pop_main.classList.remove('shown');
  
  var current_active = document.querySelector('.one-item.active');
  
  if (current_active){
    var image_link = current_active.getAttribute('data-img');
    var prod_title = current_active.getAttribute('data-title');
    var prod_tag1 = current_active.getAttribute('data-tag1');
    var prod_tag2 = current_active.getAttribute('data-tag2');
    var prod_tag3 = current_active.getAttribute('data-tag3');
    
    current_block.classList.add('filled');
    current_block.classList.remove('empty');
    current_active.classList.remove('active');
    pop_submit.classList.add('disable');
    
    var filled_length = document.querySelectorAll('.filled');
    
    filled_length = filled_length.length;
    after_content = `<input type="hidden"  value="${prod_title}" required name="properties[Lámina-${filled_length}]"><div class="image_part"> <img src="${image_link}"></div><div class="text_button"><h1 class="Heading u-h3">${prod_title}</h1><div class="tags">${prod_tag1 ? `<span class="tag">${prod_tag1}</span>`:''}${prod_tag2 ? `<span class="tag">${prod_tag2}</span>`:''}${prod_tag3 ? `<span class="tag">${prod_tag3}</span>`:''}</div><div class="select_style">${change_button_text}</div></div>`
    current_block.innerHTML = after_content;
    
    if (filled_length == limit ) {
      enabledButton();
    }
    
    buttonClick();
  }
}

disabledButton();
currentVariant();
checkLimit();
buttonClick();

// ESCUDO: Solo añade el evento si existe el botón de cerrar (pop_cross)
if (pop_cross) {
  pop_cross.addEventListener('click', function() {
    closePop();
  });
}

// ESCUDO: Solo añade el evento si existe el botón de enviar (pop_submit)
if (pop_submit) {
  pop_submit.addEventListener('click', function() {
    if (!pop_submit.classList.contains('disable')) {
      submitPop();  
    } 
  });
}

// Este evento de Shopify es seguro, pero lo dejamos bien cerrado
document.addEventListener('variant:changed', function(event) {
    if (typeof disabledButton === "function") disabledButton();
    var variant = event.detail.variant;
    if (variant) {
        current_value = variant.title;
        if (typeof checkLimit === "function") checkLimit();
        if (typeof buttonClick === "function") buttonClick();
    }
});
